import { Order } from '../types/order.type';
import { DeliveryAddress, DeliveryDay, DeliveryType, DELIVERY_TYPES } from '../types/delivery-selection.type';
import { OrderItem } from '../types/order-item.type';
import { OrderStatus } from '../types/order-status.type';
import { OrderAdvStatus } from '../types/order-adv-status.type';
import { toFormDeliveryType } from '../constants/delivery-type.constants';
import { deliveryDayFromOrder } from './format-delivery-schedule.util';

export type OrderFormState = {
  items: OrderItem[];
  deliveryType: DeliveryType;
  deliveryAddress: DeliveryAddress | null;
  billingAddress: DeliveryAddress | null;
  deliveryDay: DeliveryDay | null;
  deliveryPointId: string | null;
  organizationId: string | null;
  status: OrderStatus;
  advStatus: OrderAdvStatus;
  deliveryCost: number;
};

type ApiAddress = {
  _id?: string;
  address: string;
  zipCode: string;
  city: string;
  title?: string;
  complement?: string;
  comment?: string;
};

function mapOrderAddressToFormAddress(
  apiAddress: ApiAddress | null | undefined,
  deliveryId: string | null,
  type: DeliveryAddress['type']
): DeliveryAddress | null {
  if (!apiAddress) return null;
  return {
    type,
    _id: apiAddress._id ?? deliveryId ?? '',
    address: apiAddress.address,
    zipCode: apiAddress.zipCode,
    city: apiAddress.city,
    title: apiAddress.title,
    complement: apiAddress.complement,
    comment: apiAddress.comment,
  };
}

export function orderToFormState(order: Order): OrderFormState {
  const apiDeliveryType = order.deliveryInfos.deliveryType;
  const deliveryType = toFormDeliveryType(apiDeliveryType);

  const addressType: DeliveryAddress['type'] =
    deliveryType === DELIVERY_TYPES.relayPoint
      ? 'relay'
      : deliveryType === DELIVERY_TYPES.bioculture
      ? 'store'
      : 'home';

  return {
    items: order.items.map((item, index) => ({
      ...item,
      productId: item.productId || `virtual-${index}`,
    })),
    deliveryType,
    deliveryAddress: mapOrderAddressToFormAddress(
      order.deliveryInfos.deliveryAddress as never,
      order.deliveryInfos.deliveryId,
      addressType
    ),
    billingAddress: mapOrderAddressToFormAddress(order.deliveryInfos.deliveryBillingAddress as never, null, 'home'),
    deliveryPointId: apiDeliveryType === 'organization' ? order.deliveryInfos.deliveryId : null,
    organizationId: apiDeliveryType === 'organization' ? order.organizationId ?? null : null,
    deliveryDay: deliveryDayFromOrder(order.deliveryInfos),
    status: order.status,
    advStatus: order.advStatus,
    deliveryCost: order.deliveryCost,
  };
}
